module.exports = __webpack_public_path__ + "img/book.08031036.png";